const Button = {
    // The styles all button have in common
    baseStyle: {
        outline: 'none',  //Eliminates the default click blue border effect
        _focus:{
            boxShadow:'none'
        }
    },
};
export default Button;

